$(function(){

  setTimeout(function(){

    $('.stat-item').each(function () {

      var $this = $(this);
      var $number = $this.find('.stat-number');

      $number.waypoint({
        handler: function() {

          if($number.hasClass('animated')){
            return false;
          }

          $number.addClass('animated');

          $number.prop('Counter',0).animate({
            Counter: $number.text(),
          }, {
            duration: 2000,
            easing: 'swing',
            step: function (now) {
              $number.text(Math.ceil(now));
            },
          });

        },
        offset: '75%',
      });

    });

  }, 500);

});



// WEBPACK FOOTER //
// ./scripts/autoload/_stats.js